import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { CommonLayoutComponent } from './common/common-layout.component';
import { BranchComponent } from './branch/branch.component';
import { ClientsComponent } from './clients/clients.component';
import { RRFormComponent } from './r-r-form/r-r-form.component';
import { GatePassComponent } from './gate-pass/gate-pass.component';
import { LRFormComponent } from './l-r-form/l-r-form.component';
import { LRAcknowledgeComponent } from './l-r-acknowledge/l-r-acknowledge.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { AccessGuardService } from './_services/_auth/access-guard.service';

import {VoucherGuard} from './auth/voucher.guard';

import { DashboardComponent} from './dashboard/dashboard.component';

// Masters
import { ConsignorComponent} from './masters/consignor/consignor.component';
import { VehicleComponent} from './masters/vehicle/vehicle.component';
import { TruckComponent} from './masters/truck/truck.component';
import { OnAccountComponent} from './masters/on-account/on-account.component';
import { PartyComponent} from './masters/party/party.component';
import { DestinationComponent} from './masters/destination/destination.component';
import { ProductComponent} from './masters/product/product.component';
import { FreightMasterComponent} from './masters/freight-master/freight-master.component';
import { LrFreightMasterComponent} from './masters/lr-freight-master/lr-freight-master.component';
import { InvoiceComponent } from './invoice/invoice.component';

import { BranchMasterComponent } from './masters/branch-master/branch-master.component';
import { DistrictComponent } from './masters/district/district.component';
import { GodownComponent } from './masters/godown/godown.component';


import { VoucherComponent } from './voucher/voucher.component';



// Reports
import { TruckReportComponent } from './reports/truck-report/truck-report.component';
import { InvoiceReportComponent } from './reports/invoice-report/invoice-report.component';
import { AcknowledgeReportComponent } from './reports/acknowledge-report/acknowledge-report.component';
import { DispatchReportComponent } from './reports/dispatch-report/dispatch-report.component';
import { UsersComponent } from './users/users.component';
import { VoucherReportComponent } from './reports/voucher-report/voucher-report.component';

import { EmailComponent } from './forgot-password/email/email.component';
import { ResetPasswordComponent } from './forgot-password/reset-password/reset-password.component';




export const AppRoutes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	{
		path: 'login',
		component: SignInComponent
	},
	{
		path: 'signup',
		// canActivate: [AuthGuardService],
		component: SignUpComponent
	},
	
	{
		path: 'forgot-password',
		children: [
			{ path: '', redirectTo: 'email', pathMatch: 'full' },
			{ path: 'email', component: EmailComponent },
			{ path: 'reset-password', component: ResetPasswordComponent }
			// { path: 'password', component: PasswordComponent }
		]
	},
	{
		path: '',
		component: CommonLayoutComponent,
		children: [
			{
				path: 'dashboard',
				canActivate: [AccessGuardService],
				component: DashboardComponent
				//loadChildren: './dashboard/dashboard.module#DashboardModule'
			},
			{
				path: 'select/branch',
				canActivate: [AuthGuardService],
				component: BranchComponent
			},
			{
				path: 'users',
				canActivate: [AuthGuardService],
				component: UsersComponent
			},
			{
				path: 'select/client/:branch',
				canActivate: [AccessGuardService],
				component: ClientsComponent
			},
			{
				path: 'rrform',
				canActivate: [AccessGuardService],
				component: RRFormComponent
			},
			{
				path: 'gatepass',
				canActivate: [AccessGuardService],
				component: GatePassComponent
			},
			{
				path: 'lrform',
				canActivate: [AccessGuardService],
				component: LRFormComponent
			},
			{
				path: 'lr/ack',
				canActivate: [AccessGuardService],
				component: LRAcknowledgeComponent
			},
			{
				path: 'invoice',
				canActivate: [AccessGuardService],
				component: InvoiceComponent
			},
			{
				path: 'voucher',
				canActivate: [VoucherGuard],
				component: VoucherComponent
			},
			{
				path: 'masters',
				children: [
					{
						path: 'consignor',
						canActivate: [AccessGuardService],
						component : ConsignorComponent
					},
					{
						path: 'vehicle',
						canActivate: [AccessGuardService],
						component :VehicleComponent
					},
					{
						path: 'truck',
						canActivate: [AccessGuardService],
						component : TruckComponent
					},
					{
						path: 'onaccount',
						canActivate: [AccessGuardService],
						component : OnAccountComponent
					},
					{
						path: 'party',
						canActivate: [AccessGuardService],
						component : PartyComponent
					},
					{
						path: 'destination',
						canActivate: [AccessGuardService],
						component : DestinationComponent
					},
					{
						path: 'product',
						canActivate: [AccessGuardService],
						component : ProductComponent
					},
					{
						path: 'lr/freight',
						canActivate: [AccessGuardService],
						component : LrFreightMasterComponent
					},
					{
						path: 'freight',
						canActivate: [AccessGuardService],
						component : FreightMasterComponent
					},
					{
						path: 'branchmaster',
						canActivate: [AccessGuardService],
						component : BranchMasterComponent
					},
					{
						path: 'district',
						canActivate: [AccessGuardService],
						component : DistrictComponent
					},
					{
						path: 'godown',
						canActivate: [AccessGuardService],
						component : GodownComponent
					}
				]
			},
			{
				path: 'reports',
				children: [
					// {
					// 	path: 'truckwise',
					// 	canActivate: [AccessGuardService],
					// 	component : TruckReportComponent
					// },
					// {
					// 	path: 'acknowledgedwise',
					// 	canActivate: [AccessGuardService],
					// 	component :AcknowledgeReportComponent
					// },
					{
						path: 'invoice',
						canActivate: [AccessGuardService],
						component : InvoiceReportComponent
					},
					{
						path: 'dispatch',
						canActivate: [AccessGuardService],
						component : DispatchReportComponent
					},
					{
						path: 'voucher_report',
						canActivate: [VoucherGuard],
						component : VoucherReportComponent
					}
				]
			}
		]
	}
];




// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/app.routing.ts